'use client';

import {
  addHooksToOneTrustButtons,
  configureSegmentOt,
  formatOneTrustElements,
  loadSegment,
  processQueue,
} from '@frameio/segment-ot';
import Script from 'next/script';

import getIntegrations from '~/analytics/getIntegrations';
import trackEventSegment from '~/analytics/trackEventSegment';

async function onLoad() {
  configureSegmentOt({
    track: trackEventSegment,
    groupRestrictions: [],
    segmentWriteKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
    shouldIncludeIntegrations: true,
  });
  if (window && window.adobePrivacy) {
    await window.adobePrivacy.loadOneTrust();
  }
  await loadSegment({
    integrations: getIntegrations(),
  });
  formatOneTrustElements();
  processQueue();
  addHooksToOneTrustButtons();
}

const Segment = () => {
  // prevent resetting segment on re-render
  if (typeof window !== 'undefined' && window?.analytics) {
    return null;
  }

  return (
    <>
      <Script
        id="manage-cookies-script"
        dangerouslySetInnerHTML={{
          __html: `!function(){window.fedsConfig = window.fedsConfig || {}; window.fedsConfig.privacy
          = window.fedsConfig.privacy || {};
          window.fedsConfig.privacy.otDomainId =
          '${process.env.NEXT_PUBLIC_ANALYTICS_DOMAIN_ID}';
          window.fedsConfig.privacy.documentLanguage = true;
          window.fedsConfig.privacy.footerLinkSelector = '#manage-cookies';}();`,
        }}
      />

      <Script
        id="privacy-script"
        src="https://www.adobe.com/etc.clientlibs/globalnav/clientlibs/base/privacy-standalone.js"
        strategy="lazyOnload"
        onLoad={onLoad}
      ></Script>
    </>
  );
};

export default Segment;
